// extracted by mini-css-extract-plugin
export default {"Main":"HomePage_Main__lQwHZ","Main_text":"HomePage_Main_text__L58Of"};